import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { StepHeading, Form } from 'components/GetStarted/styles'
import { trackClickEvent } from 'utils/Analytics'
import TextInput from 'components/generic/Input/TextInput'
import PrimaryButton from 'components/generic/PrimaryButton'
import InputErrorMessage from 'components/generic/Input/InputErrorMessage'
import { AppContext } from 'contexts/AppContext'

const StepEnterName = ({ onStepComplete, userInput }) => {
  const { domain } = useContext(AppContext)
  const { register, handleSubmit, errors, formState } = useForm({
    mode: 'all',
    defaultValues: {
      first_name: userInput?.first_name,
      last_name: userInput?.last_name,
    },
  })
  const { isValid } = formState

  return (
    <Form onSubmit={handleSubmit(onStepComplete)}>
      <StepHeading>What should they call you?</StepHeading>
      <TextInput
        id='user-first-name'
        autoFocus={true}
        name='first_name'
        label='First Name'
        isValid={!errors.first_name}
        ref={register({ required: 'Please enter a first name.' })}
      />
      <InputErrorMessage errors={errors} inputId='user-first-name' name='first_name' />

      <TextInput
        id='user-last-name'
        name='last_name'
        label='Last Name'
        isValid={!errors.last_name}
        ref={register({ required: 'Please enter a last name.' })}
      />
      <InputErrorMessage errors={errors} inputId='user-last-name' name='last_name' />

      <PrimaryButton
        mt='2rem'
        disabled={!isValid}
        onClick={() => trackClickEvent(domain, 'get-started-next-user-full-name')}
      >
        Next
      </PrimaryButton>
    </Form>
  )
}

export default StepEnterName
